import { render, staticRenderFns } from "./UploadFilesModal.vue?vue&type=template&id=2f413d38"
import script from "./UploadFilesModal.vue?vue&type=script&lang=js"
export * from "./UploadFilesModal.vue?vue&type=script&lang=js"
import style0 from "./UploadFilesModal.vue?vue&type=style&index=0&id=2f413d38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports